export default "__VITE_ASSET__CoaPzgBg__"